import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_SEARCH_USER } from "../../../config/api";

export const searchUsers = createAsyncThunk(
  "users/search",
  async (searchTerm, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "GET",
        path: `${API_SEARCH_USER}${encodeURIComponent(searchTerm || "")}`,
      });

      return response?.data?.data || [];
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
